/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dry_Green_Toad_NapInputs */

const en_dry_green_toad_nap = /** @type {(inputs: Dry_Green_Toad_NapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const de_dry_green_toad_nap = /** @type {(inputs: Dry_Green_Toad_NapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Dry_Green_Toad_NapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dry_green_toad_nap = /** @type {((inputs?: Dry_Green_Toad_NapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dry_Green_Toad_NapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dry_green_toad_nap(inputs)
	return de_dry_green_toad_nap(inputs)
});